var defaultProps = {
  containerProps: {},
  innerRef: null,
  className: '',
  style: {},
  leftAddon: null,
  rightAddon: null
};

export { defaultProps };
//# sourceMappingURL=defaultProps.js.map
